import { useEffect } from 'react';
import { LocalTokens } from '../../types/auth';
import { v4 as uuidv4 } from 'uuid';

export const useStorage = () => {
  useEffect(() => {
    if (!sessionStorage.getItem(LocalTokens.sessionId)) {
      const uid = uuidv4();
      sessionStorage.setItem(LocalTokens.sessionId, uid);
    }
    const handlePageHide = (event: PageTransitionEvent) => {
      // Keep the session ID when the page goes into the back/forward cache,
      // since restoring it does not re-run this effect.
      if (event.persisted) return;
      sessionStorage.setItem(LocalTokens.sessionId, '');
    };
    window.addEventListener('pagehide', handlePageHide);
    return () => window.removeEventListener('pagehide', handlePageHide);
  }, []);
};
